import $ from "jquery";

$(function() {
  $("input[type=radio]").click(function() {
    var lastFilled = $(this);
    setTimeout(function() {
      var parentElement = $(lastFilled).closest(".wm_form_element");
      var nextElement = parentElement.nextAll(":visible:first");
      if (nextElement.length > 0) {
        $("html, body").animate(
          {
            scrollTop: nextElement.offset().top - 110
          },
          900
        );
      }
    }, 100);
  });
});
